import { useEffect, useState } from "react";
import axios from "axios";
import { zonesWithProducts } from "../../utils/options";
import { getAxiosConfig, getMinioImage } from "../../utils/helpers";
import MaterialList from "./MaterialList";
import BestZones from "./BestZones";
import Banner from "./Banner";
import ExploreMore from "./ExploreMore";
import Essentials from "./Essentials";
import CenterWrapper from "./CenterWrapper";
import BrandList from "./BrandList";

const IntroPage = () => {
  const [zoneImagesCache, setZoneImagesCache] = useState({});

  useEffect(() => {
    const fetchAllZoneImages = async () => {
      try {
        const zonePromises = zonesWithProducts.map(async (zoneEntry) => {
          const apiCalls = zoneEntry.products.map((product) =>
            axios
              .get(
                `${process.env.REACT_APP_BACK_URL}/api/material/get-all`,
                getAxiosConfig({
                  search: product.name,
                  page: 1,
                  limit: 30,
                }),
              )
              .catch((error) => {
                console.error(`Error fetching ${product.name}:`, error);
                return null;
              }),
          );

          const results = await Promise.all(apiCalls);
          const allImages = results
            .filter((result) => result !== null)
            .flatMap((result) => {
              const collections = result?.data?.data?.collections || [];
              return collections.flatMap(
                (collection) => collection?.images || [],
              );
            })
            .filter(Boolean)
            .map((image) => getMinioImage(image))
            .filter(Boolean);
          console.log({ allImages });

          return { zone: zoneEntry.zone, images: allImages };
        });

        const zoneResults = await Promise.all(zonePromises);
        const cacheObj = zoneResults.reduce((acc, { zone, images }) => {
          acc[zone] = images;
          return acc;
        }, {});
        setZoneImagesCache(cacheObj);
      } catch (error) {
        console.error("Error prefetching zone images:", error);
      }
    };

    fetchAllZoneImages();
  }, []);

  return (
    <div className="space-y-8">
      <Banner />
      <CenterWrapper className={"space-y-8"}>
        <MaterialList />
        <BrandList />
        <BestZones zoneImages={zoneImagesCache} />
        <ExploreMore />
        <Essentials zoneImages={zoneImagesCache} />
      </CenterWrapper>
    </div>
  );
};

export default IntroPage;
